export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11064.6f9074c6.jpg";